import addTruthyParamsToUrl from './addTruthyParamsToUrl';

// Append `next` query parameter to a URL, if provided.
const urlWithNext = (url, next) => addTruthyParamsToUrl(url, { next });

export default urlWithNext;
